import { UI_UNSET, UI_UNSET_VALUE } from '../../types/settings'
import { ISettingsAdapter, ISettingsAdapterArgs, SettingsAdapter } from './settingsAdapter'

export type ICSVAdapterArgs = Omit<
  ISettingsAdapterArgs<string[] | null, string, string | UI_UNSET>,
  'toUiValue' | 'toRawValue'
>

export const CSVAdapter = ({
  inputName,
  variable,
  type,
  defaultRawValue,
  initialUiValue = UI_UNSET_VALUE,
  skipFormPopulateOnLoad,
  shouldUseRawValue,
  shouldTreatAsUnset,
  schema
}: ICSVAdapterArgs): ISettingsAdapter<string[] | null, string, string | UI_UNSET> => {
  const toUiValue = (rawValue: any): string => (Array.isArray(rawValue) ? rawValue.join(', ') : '')

  const toRawValue = (uiValue: string | undefined | null): string[] =>
    uiValue ? uiValue.split(',').map(email => email.trim()) : []

  return SettingsAdapter<string[] | null, string, string | UI_UNSET>({
    inputName,
    variable,
    type,
    defaultRawValue,
    initialUiValue,
    toUiValue,
    toRawValue,
    skipFormPopulateOnLoad,
    shouldUseRawValue,
    shouldTreatAsUnset,
    schema
  })
}
